import { MessageCircle } from "lucide-react"
import footerConfig from "../../data/footer-config.json"

export function FooterCommunityLink() {
  return (
    <a
      href={footerConfig.links.farcasterJoin}
      target="_blank"
      rel="noopener noreferrer"
      className="hidden items-center gap-[0.24rem] text-white/65 hover:text-white transition-colors lg:flex"
    >
      <MessageCircle className="w-[0.88rem] h-[0.88rem]" />
      <span className="text-[0.84rem]">Community</span>
    </a>
  )
}

export function FooterSocialLinks() {
  return (
    <div className="hidden md:flex items-center gap-[0.72rem] mr-[0.24rem]">
      <a
        href={footerConfig.links.twitter}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Twitter"
        className="text-white opacity-75 hover:opacity-100 hover:text-white transition-colors"
      >
        <svg className="w-[0.88rem] h-[0.88rem]" fill="currentColor" viewBox="0 0 24 24">
          <title>Twitter</title>
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      </a>

      <a
        href={footerConfig.links.farcaster}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Farcaster"
        className="text-white/65 opacity-70 hover:opacity-100 hover:text-white transition-colors"
      >
        <img src={footerConfig.icons.farcaster} alt="Farcaster" className="w-[0.86rem] h-[0.86rem]" />
      </a>
    </div>
  )
}
